import { render, staticRenderFns } from "./FlowSteps.vue?vue&type=template&id=f8397036&scoped=true"
import script from "./FlowSteps.vue?vue&type=script&lang=js"
export * from "./FlowSteps.vue?vue&type=script&lang=js"
import style0 from "./FlowSteps.vue?vue&type=style&index=0&id=f8397036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8397036",
  null
  
)

export default component.exports